import React, { useEffect, useState } from 'react';
import { map, forEach, groupBy, find } from 'lodash-es';
import { productCategories } from '../constants';
import ProductAddModal from './ProductAddModal';
import ProductList from './ProductList';
import { getUrlParam, showConfirmation } from '../util';

const ProductCategories = (props) => {
	const { httpService } = props;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalParams, setModalParams] = useState({});
	const [data, setData] = useState({});

	const categories = map(
		Object.keys(productCategories),
		(x) => productCategories[x],
	);

	const fetchData = async (httpService) => {
		const bookingId = getUrlParam('bookingId');
		try {
			const result = await Promise.all([
				httpService.getProductCategoriesAsync(),
				httpService.getBookingProductsAsync(bookingId),
			]);

			const categories = result[0];
			const bookingProducts = result[1];

			forEach(bookingProducts, (x) => {
				x.productCategory = find(
					categories,
					(y) => y.id === x.productCategoryId,
				);
			});

			const grouppedData = groupBy(
				bookingProducts,
				(x) => x.productCategory.type,
			);

			setData(grouppedData);
		} catch (err) {
			debugger;
		}
	};

	const onSaveProduct = async (payload) => {
		await httpService.postBookingProductAsync(payload);
		await fetchData(httpService);

		setIsModalOpen(false);
	};

	const onAddProductClicked = () => {
		if (!isModalOpen) setIsModalOpen(true);
	};

	const onRequestClose = () => {
		setIsModalOpen(false);
	};

	const onAfterClose = () => {
		setModalParams({});
	};

	const onRemoveProductClicked = async (productId) => {
		showConfirmation({
			title: 'Brisanje Proizvoda',
			message: 'Jeste li sigurni da želite obrisati proizviod?',
			onConfirm: async () => {
				await httpService.deleteBookingProductAsync(productId);
				await fetchData(httpService);
			},
		});
	};

	const onAddToCategory = async (category) => {
		setModalParams({
			category,
		});
		setIsModalOpen(true);
	};

	useEffect(() => {
		fetchData(httpService);
	}, []);

	return (
		<div className="register-categories">
			<div className="categories-toolbar">
				<h1>Proizvodi</h1>
				{/* <button onClick={onAddProductClicked}>Dodaj proizvode</button> */}
			</div>
			<p style={{ marginBottom: '20px' }}>
				Proizvode upisujete kako biste mogli sudjelovati u dodjeli
				nagrada za najbolje proizvode sajma po izboru posjetitelja
				"WineOs 2025. People's Choice" te kako bi u online katalogu bilo
				vidljivo što ćete izlagati.
			</p>
			<div className="">
				{map(categories, (x) => (
					<ProductList
						key={x.type}
						category={x}
						data={data[x.type] ?? []}
						onAddToCategory={onAddToCategory}
						onRemoveProductClicked={onRemoveProductClicked}
					/>
				))}
			</div>
			{isModalOpen && (
				<ProductAddModal
					modalParams={modalParams}
					isOpen={isModalOpen}
					onSave={onSaveProduct}
					onRequestClose={onRequestClose}
					onAfterClose={onAfterClose}
					httpService={httpService}
				/>
			)}
		</div>
	);
};

export default ProductCategories;
